// Selettore di tema chiaro/scuro.
//
// Niente emoji: ☀ e ☾ vengono disegnate in modo diverso da iOS, Android e dai
// vari desktop, cambiano dimensione e allineamento, e su alcune piattaforme
// arrivano a colori — quindi ignorerebbero il token del tema proprio nel
// componente che serve a cambiarlo. Due SVG inline con stroke="currentColor"
// prendono il colore dal CSS e sono identici ovunque.
//
// L'SVG e' aria-hidden: l'etichetta accessibile e' sul <button>, altrimenti un
// lettore di schermo annuncerebbe due volte lo stesso comando.

function IconaSole() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.8" strokeLinecap="round" aria-hidden="true" focusable="false">
      <circle cx="12" cy="12" r="4.2" />
      <path d="M12 2.2v2.4M12 19.4v2.4M2.2 12h2.4M19.4 12h2.4M5.1 5.1l1.7 1.7M17.2 17.2l1.7 1.7M18.9 5.1l-1.7 1.7M6.8 17.2l-1.7 1.7" />
    </svg>
  );
}

function IconaLuna() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d="M20.5 14.6A8.6 8.6 0 0 1 9.4 3.5a8.6 8.6 0 1 0 11.1 11.1z" />
    </svg>
  );
}

export default function ThemeToggle({ tema, onCambia, className = '' }) {
  return (
    <div className={`cps-tema-switch ${className}`} role="group" aria-label="Tema">
      <button
        type="button"
        className={tema === 'chiaro' ? 'active' : ''}
        aria-label="Tema chiaro"
        aria-pressed={tema === 'chiaro'}
        onClick={() => onCambia('chiaro')}
      ><IconaSole /></button>
      <button
        type="button"
        className={tema === 'scuro' ? 'active' : ''}
        aria-label="Tema scuro"
        aria-pressed={tema === 'scuro'}
        onClick={() => onCambia('scuro')}
      ><IconaLuna /></button>
    </div>
  );
}
